import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { ResponsibleGamingSettingsData } from "../../../../model/data/ResponsibleGamingSettingsData";
import { GameConstants } from "../../constant/GameConstants";
/**
 * GetSettingsResponseData.ts
 */
export class GetSettingsResponseData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        let settings = this.data.getDataObject(GameConstants.PROPERTY_SETTINGS);
        if (settings) {
            this.settings = new ResponsibleGamingSettingsData(settings);
        }
    }
    getSettings() {
        return this.settings;
    }
}
//# sourceMappingURL=GetSettingsResponseData.js.map